import { render, staticRenderFns } from "./SideShotResultOverview.vue?vue&type=template&id=558e13d6&scoped=true&"
import script from "./SideShotResultOverview.vue?vue&type=script&lang=ts&"
export * from "./SideShotResultOverview.vue?vue&type=script&lang=ts&"
import style0 from "./SideShotResultOverview.vue?vue&type=style&index=0&id=558e13d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558e13d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VContainer,VIcon,VProgressCircular,VRow})
